import { PlusIcon, HandRaisedIcon, TrashIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";

export const SuggestionCardActions = ({
  mapMode,
  suggestion,
  isPickedUpByMe,
  isPickedUpByOther,
  isSuperAdmin,
  handlePickUp,
  pickingUp,
  onUpdateStatus,
  handleCreate,
  moreMenuRef,
  showMoreMenu,
  setShowMoreMenu,
  handleReturnToPool,
  showAssign,
  setShowAssign,
  handleAssign,
  hosts,
  handleDelete,
}) => {
  return (
        <div className={`border-t border-gray-100 dark:border-gray-800 px-4 py-3 flex flex-col gap-2 bg-gray-50 dark:bg-gray-800${mapMode ? " sticky bottom-0 z-10" : ""}`}>

          {/* Main action row */}
          <div className="flex items-center gap-2">
            {suggestion.status === "pending" && !isPickedUpByMe && !isPickedUpByOther && (
              <>
                <button
                  onClick={handlePickUp}
                  disabled={pickingUp}
                  className="flex-1 inline-flex justify-center items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-white hover:bg-primaryDark disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  <HandRaisedIcon className="h-4 w-4" />
                  {pickingUp ? "Claiming..." : "Claim"}
                </button>
                {isSuperAdmin && (
                  <button
                    onClick={() => onUpdateStatus(suggestion.id, "rejected")}
                    className="inline-flex items-center gap-1 rounded-md border border-gray-200 dark:border-gray-700 px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    <XCircleIcon className="h-3 w-3" />
                    Reject
                  </button>
                )}
              </>
            )}
            {suggestion.status === "pending" && isPickedUpByMe && (
              <>
                <button
                  onClick={handleCreate}
                  className="flex-1 inline-flex justify-center items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-white hover:bg-primaryDark"
                >
                  <PlusIcon className="h-4 w-4" />
                  Create Event
                </button>
                <div className="relative" ref={moreMenuRef}>
                  <button
                    onClick={() => setShowMoreMenu((v) => !v)}
                    className="inline-flex items-center rounded-md border border-gray-200 dark:border-gray-700 px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    •••
                  </button>
                  {showMoreMenu && (
                    <div className="absolute right-0 bottom-full mb-1 w-44 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg z-10 py-1">
                      <button
                        onClick={() => { handleReturnToPool(); setShowMoreMenu(false); }}
                        className="w-full text-left px-3 py-2 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                      >
                        Return to pool
                      </button>
                      {isSuperAdmin && (
                        <>
                          {showAssign ? (
                            <div className="px-3 py-2">
                              <select
                                autoFocus
                                className="w-full text-xs border border-gray-200 dark:border-gray-700 rounded px-1.5 py-0.5 focus:outline-none focus:ring-1 focus:ring-primary bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200"
                                defaultValue=""
                                onChange={(e) => { if (e.target.value) { handleAssign(e.target.value); setShowMoreMenu(false); } }}
                                onBlur={() => setShowAssign(false)}
                              >
                                <option value="" disabled>Assign to...</option>
                                {hosts.map((h) => (
                                  <option key={h.id} value={h.id}>{h.name || h.email || h.id}</option>
                                ))}
                              </select>
                            </div>
                          ) : (
                            <button
                              onClick={() => setShowAssign(true)}
                              className="w-full text-left px-3 py-2 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                            >
                              Reassign
                            </button>
                          )}
                          <div className="my-1 border-t border-gray-100 dark:border-gray-800" />
                          <button
                            onClick={() => { handleDelete(); setShowMoreMenu(false); }}
                            className="w-full text-left px-3 py-2 text-xs text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/40"
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
            {suggestion.status === "pending" && isPickedUpByOther && isSuperAdmin && (
              <>
                <button
                  onClick={handleCreate}
                  className="flex-1 inline-flex justify-center items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-white hover:bg-primaryDark"
                >
                  <PlusIcon className="h-4 w-4" />
                  Create Event
                </button>
                <div className="relative" ref={moreMenuRef}>
                  <button
                    onClick={() => setShowMoreMenu((v) => !v)}
                    className="inline-flex items-center rounded-md border border-gray-200 dark:border-gray-700 px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    •••
                  </button>
                  {showMoreMenu && (
                    <div className="absolute right-0 bottom-full mb-1 w-44 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg z-10 py-1">
                      <button
                        onClick={() => { handleReturnToPool(); setShowMoreMenu(false); }}
                        className="w-full text-left px-3 py-2 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                      >
                        Return to pool
                      </button>
                      {showAssign ? (
                        <div className="px-3 py-2">
                          <select
                            autoFocus
                            className="w-full text-xs border border-gray-200 dark:border-gray-700 rounded px-1.5 py-0.5 focus:outline-none focus:ring-1 focus:ring-primary bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200"
                            defaultValue=""
                            onChange={(e) => { if (e.target.value) { handleAssign(e.target.value); setShowMoreMenu(false); } }}
                            onBlur={() => setShowAssign(false)}
                          >
                            <option value="" disabled>Assign to...</option>
                            {hosts.map((h) => (
                              <option key={h.id} value={h.id}>{h.name || h.email || h.id}</option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <button
                          onClick={() => setShowAssign(true)}
                          className="w-full text-left px-3 py-2 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                        >
                          Reassign
                        </button>
                      )}
                      <div className="my-1 border-t border-gray-100 dark:border-gray-800" />
                      <button
                        onClick={() => { handleDelete(); setShowMoreMenu(false); }}
                        className="w-full text-left px-3 py-2 text-xs text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/40"
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>

          {suggestion.status === "converted" && (
            <div className="flex items-center gap-2">
              <span className="flex-1 flex items-center gap-1 text-xs font-semibold text-green-700 dark:text-green-300">
                <CheckCircleIcon className="h-4 w-4 text-green-500 dark:text-green-400" />
                Converted
              </span>
              <div className="relative" ref={moreMenuRef}>
                <button
                  onClick={() => setShowMoreMenu((v) => !v)}
                  className="inline-flex items-center rounded-md border border-gray-200 dark:border-gray-700 px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  •••
                </button>
                {showMoreMenu && (
                  <div className="absolute right-0 bottom-full mb-1 w-44 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg z-10 py-1">
                    <button
                      onClick={() => { handleReturnToPool(); setShowMoreMenu(false); }}
                      className="w-full text-left px-3 py-2 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                      Return to pool
                    </button>
                    {isSuperAdmin && (
                      <>
                        <div className="my-1 border-t border-gray-100 dark:border-gray-800" />
                        <button
                          onClick={() => { handleDelete(); setShowMoreMenu(false); }}
                          className="w-full text-left px-3 py-2 text-xs text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/40"
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          {suggestion.status === "approved" && (
            <>
              <span className="flex items-center gap-1 text-xs font-semibold text-green-700 dark:text-green-300">
                <CheckCircleIcon className="h-4 w-4 text-green-500 dark:text-green-400" />
                Event Created
              </span>
              <button
                onClick={() => onUpdateStatus(suggestion.id, "rejected")}
                className="inline-flex items-center gap-1 rounded-md border border-gray-200 dark:border-gray-700 px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                Reject
              </button>
            </>
          )}
          {suggestion.status === "rejected" && (
            <>
              <span className="flex items-center gap-1 text-xs font-medium text-gray-400 dark:text-gray-500">
                <XCircleIcon className="h-4 w-4" />
                Rejected
              </span>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onUpdateStatus(suggestion.id, "pending")}
                  className="flex-1 inline-flex justify-center items-center gap-1 rounded-md border border-gray-200 dark:border-gray-700 px-2 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                  Restore
                </button>
                {isSuperAdmin && (
                  <button
                    onClick={handleDelete}
                    className="inline-flex items-center gap-1 rounded-md border border-red-200 dark:border-red-800 px-2 py-1 text-xs font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/40"
                  >
                    <TrashIcon className="h-3 w-3" />
                    Delete
                  </button>
                )}
              </div>
            </>
          )}
        </div>
  );
};
